var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm._errors.first(_vm.field))?_c('p',{staticClass:"text-danger",class:_vm.getClass},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),(_vm.responseErrorMessage)?_c('p',{staticClass:"text-danger",class:_vm.getClass},[_vm._v(_vm._s(_vm.responseErrorMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }